<template>
  <section class="heroheader heroheader--video">
    <div class="heroheader-inner">
      <h1
        v-if="heroTitle"
        class="heroheader-title"
      >
        {{ heroTitle }}
      </h1>
      <kf-button
        v-if="heroVideoSrc"
        class="btn"
        type="primary"
        @click.prevent="showModal()"
      >
        {{ i18n.playButtonLabel }}
      </kf-button>
    </div>
    <video
      class="heroheader-video"
      autoplay
      loop
      muted
      :poster="heroVideoStillImage"
    >
      <source
        v-if="heroVideoSrc"
        :src="heroVideoSrc"
        type="video/mp4"
      >
    </video>
    <div class="heroheader__bottom-curve">
      <CurveHeader class="icon" />
    </div>
    <modal
      v-show="isModalVisible"
      :modal="isModalVisible"
      @close="closeModal"
    >
      <template slot="body">
        <video
          v-if="heroVideoSrc"
          ref="modal-video"
          class="modal-video"
          preload="auto"
          controls
          loop
          :poster="heroVideoStillImage"
        >
          <source
            :src="heroVideoSrc"
            type="video/mp4"
          >
        </video>
      </template>
    </modal>
  </section>
</template>

<script>
import TailwindMixin from '@/mixins/TailwindMixin';

export default {
  name: 'HeroHeaderVideo',
  components: {
    Modal: () => import(/* webpackChunkName: "main" */ '@/components/modal/Modal.vue'),
    KfButton: () => import(/* webpackChunkName: "main" */ '@/components/base/button/Button.vue'),
    CurveHeader: () => import(/* webpackChunkName: "main"*/ '@/components/svg/CurveHeader.vue'),
  },
  mixins: [TailwindMixin],
  props: {
    i18n: {
      type: Object,
      default: null,
    },
    heroVideoStillImageLarge: {
      type: String,
      default: '',
    },
    heroVideoStillImageMobile: {
      type: String,
      default: '',
    },
    heroTitle: {
      type: String,
      default: '',
    },
    heroVideoSrc: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isMuted: true,
      isModalVisible: false,
      modalContent: null,
    };
  },
  computed: {
    heroVideoStillImage() {
      if (this.doesWindowHaveMinWidthXs) {
        return this.heroVideoStillImageLarge;
      }
      return this.heroVideoStillImageMobile;
    },
  },
  methods: {
    toggleMute() {
      this.isMuted = !this.isMuted;
    },
    showModal() {
      this.isModalVisible = true;
      document.body.classList.add('is-locked');
    },
    closeModal() {
      this.isModalVisible = false;
      this.pauseVideo();
      document.body.classList.remove('is-locked');
    },
    pauseVideo() {
      if (this.$refs['modal-video']) {
        this.$refs['modal-video'].pause();
      }
    },
  },
};
</script>

<style lang="postcss" scoped>
.heroheader {
  @apply w-full flex flex-col justify-center pb-8 relative bg-primary-bravo;
  min-height: 350px;

  @screen md {
    min-height: 775px;
  }

  &__bottom-curve {
    @apply block absolute left-0 bottom-0 w-full h-0 overflow-hidden z-10;
    padding-bottom: calc(140 / 1440 * 100%);

    & > svg {
      @apply absolute top-0 left-0 w-full h-full fill-current text-white;
    }
  }

  &-video {
    @apply absolute w-full h-full opacity-80 object-cover top-0 left-0;
    z-index: 1;
  }

  &-title {
    @apply text-white font-playfair text-10xl mb-12 text-center font-bold;
    text-shadow: 0 2px 2px rgba(0, 0, 0, 0.65);

    @screen lg {
      @apply text-9xl;
    }

    @screen xl {
      @apply text-11xl;
    }
  }

  &-btn-audio {
    @apply flex justify-center items-center rounded-full;
    width: 64px;
    height: 64px;
    background-color: rgba(255, 255, 255, 0.3);
  }

  &--video {
    @apply overflow-hidden;

    .heroheader-inner {
      @apply flex flex-col justify-center mx-auto relative z-10 container max-w-5xl overflow-hidden items-center;
    }

    >>> .modal {
      max-width: 1380px;
      max-height: 1024px;
      background-color: transparent;
      box-shadow: none;

      .btn-close {
        top: 44px;
        right: -30px;
      }

      &-video {
        max-height: 600px;
        object-fit: cover;
      }

      &-body {
        video {
          width: 100%;
          border-radius: 16px;
        }
      }

      &-header {
        height: 24px;
        border: 0;
      }
    }
  }
}
</style>
